module.exports = __webpack_public_path__ + "img/recommended-people.d1145657.svg";